import axios from 'axios';

const unsubscribeFromListing = async (
  dashboardId: string,
  listingId?: string,
) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/subscriptions${
      listingId ? `/${listingId}` : ''
    }`,
    method: 'delete' as const,
  };

  await axios.request<{ id: string }>(config);
};

export default unsubscribeFromListing;
